module.exports = __webpack_public_path__ + "img/strava.71f06fe7.png";